import { jsx as _jsx } from "react/jsx-runtime";
import { Stack } from "@mui/material";
import { FilterOption } from "../../Atoms";
/**
 * Display the available filtering options for a given filter selection
 */
var FilteringOptions = function (_a) {
    var selectOption = _a.selectOption, options = _a.options, currentOption = _a.currentOption;
    return (_jsx(Stack, { children: options.map(function (option) { return (_jsx(FilterOption, { selectOption: selectOption, filterOption: option, active: currentOption === option.type }, option.label)); }) }));
};
export default FilteringOptions;
